import "./participantChange.css";
import * as ConversationEntryUtil from "../helpers/conversationEntryUtil";
import { util } from "../helpers/common";
import { t } from "../awac/i18n";

// Friendly name shown in the widget header; used in place of internal
// bot/deployment names (e.g. "Pilot - Buyer Engagement Agent - Gab V2").
const AGENT_DISPLAY_NAME = 'Lia';

export default function ParticipantChange({conversationEntry}) {
    /**
     * Maps internal agent/bot participant names to the widget's friendly
     * agent name. Human participants keep their own name.
     * @returns {string}
     */
    function getDisplayName(rawName) {
        if (!rawName || /pilot|agent|bot/i.test(rawName)) {
            return AGENT_DISPLAY_NAME;
        }
        return rawName;
    }

    /**
     * Generates a text with the participant change operation infomation.
     * @returns {string}
     */
    function generateParticipantChangeText() {
        const participantName = getDisplayName(ConversationEntryUtil.getParticipantChangeEventPartcipantName(conversationEntry));
        const hasParticipantJoined = ConversationEntryUtil.hasParticipantJoined(conversationEntry);
        const formattedTime = util.getFormattedTime(conversationEntry.transcriptedTimestamp);
        const participantChangeText = t(hasParticipantJoined ? "chat.joined" : "chat.left", { name: participantName, time: formattedTime });

        return participantChangeText;
    }

    return (
        <p className="participantChangeText">{generateParticipantChangeText()}</p>
    );
}